import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "SemestrePage",
    data() {
        let ss = new MainService();
        return {
            msg: "SemestrePage",
            ss: ss,
            ajax: {
                "url": ss.indexSemestre(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Semestre', name: 'Semestre', title: 'Semestre' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            semestres: [],
            semestre: {},
            isLoading: false,
            errorBag: {},
            auth : null,
        };
    },
    methods: {
        newSemestre() {
            this.semestre = {};
            this.$refs['frm-semestre'].show();
        },
        showSemestre(id) {
            this.isLoading=true;
            this.ss.showSemestre(id).then(
                (result) => {
                    let response = result.data;
                    this.semestre = response.data;
                    this.$refs['view-semestre'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editSemestre() {
            this.$refs['frm-semestre'].show();
            this.$refs['view-semestre'].hide();
        },
        cancelSemestre() {
            if (this.semestre.id) {
                this.$refs['view-semestre'].show();
            }
            this.$refs['frm-semestre'].hide();
        },
        saveSemestre() {
            this.ss.storeSemestre(this.semestre).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-semestre'].hide();
                    this.$refs['datatable-semestre'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteSemestre() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
                buttons: true,
                dangerMode: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                        this.ss.destroySemestre(this.semestre)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-semestre'].hide();
                                this.$refs['datatable-semestre'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Semestre').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showSemestre(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var usuario = JSON.parse(localStorage.getItem('usuario'));
        if (!usuario) {
          this.$router.push('/Login');
        }else{
            this.auth = usuario;
        }
    }
};
